import React from 'react';
import { Link } from 'react-router-dom';
import { ID, withCodes } from 'app/blocks/common/codes';
import { MainTitle, SubTitle } from 'app/blocks/titles/titles';
import AdvanceSearchButtons from 'app/pages/search/advance-search-buttons/AdvanceSearchButtons';
import { navigate } from 'app/route/history';

function NoArticleResults(props) {
    const search = props.codes.SEARCH_CODES.SEARCH.NO_RESULTS;

    const onBackToArticleSearch = () => {
        if (props.goBack) {
            props.goBack();
        } else {
            navigate('/index.html/advancedsearch');
        }
    };

    return (
        <div className="col-12">
            <div className="MissingArticleDetails-Header NoTopMargin">
                <MainTitle>{search.title}</MainTitle>
                <div className="Description" dangerouslySetInnerHTML={{ __html: search.description }} />
            </div>
            <div className="MissingArticleDetails-FormContent">
                <SubTitle data-seleniumid="no-results">{search.not_found}</SubTitle>
                <ul className="LinksList">
                    <li data-seleniumid="change-search">
                        <Link data-seleniumid="change-search-link" onClick={onBackToArticleSearch}>
                            <strong>{search.return_link}</strong>
                        </Link>{' '}
                        {search.return_text}
                    </li>
                    <li data-seleniumid="get-help">
                        <Link data-seleniumid="get-help-link" to="/index.html/get-help-on-article">
                            <strong>{search.help_link}</strong>
                        </Link>{' '}
                        {search.help_text}
                    </li>
                </ul>
            </div>
            <AdvanceSearchButtons hideNext onPrevious={onBackToArticleSearch} previousBtnText={search.btn_txt} />
        </div>
    );
}

export default withCodes(NoArticleResults, ID.SEARCH_CODES);
